import moment from 'moment';
import camelCase from 'lodash/camelCase';
import { useTranslation } from 'react-i18next';

import {
  EmptyContainer,
  PLATFORM_THEME_COLORS,
  Typography,
  EMPTY_ILLUSTRATIONS,
} from '@thinknet-gmbh/platform-common-ui';

import {
  InfoBlock,
  InfoElement,
  InfoWrapper,
} from 'src/pages/employee/sub-pages/employee-details-limited-view/employee-details-limited-view.styles';
import { displayAddress } from 'src/common/helpers/common.helpers';

const LimitedWorkingConditions = ({ workingCondition }: { workingCondition: any }) => {
  const { t } = useTranslation(['common', 'employee', 'settings']);

  if (!workingCondition) {
    return <EmptyContainer illustration={EMPTY_ILLUSTRATIONS.dataAnalysis} />;
  }

  return (
    <InfoWrapper>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.employmentType')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(
              `employee:workingConditions.labels.${workingCondition.employmentType.toLowerCase()}`
            )}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.hireDate')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {moment(workingCondition.hireDate).format('DD.MM.YYYY')}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('settings:company.labels.companyName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {workingCondition.company.name}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.location')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {workingCondition.companyLocation.name}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.businessAddress')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {displayAddress(workingCondition.companyBusinessAddress)}
          </Typography>
        </InfoElement>
      </InfoBlock>
      <InfoBlock>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.department')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {workingCondition.companyDepartment.name}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.supervisor')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>-</Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('common:labels.jobTitle')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {workingCondition.job.title}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t('employee:labels.occupationType')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(`employee:workingConditions.labels.${camelCase(workingCondition.occupationType)}`)}
          </Typography>
        </InfoElement>
        <InfoElement>
          <Typography weight="bold">{`${t(
            'employee:workingConditions.labels.paidVacation'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{`${
            workingCondition.paidVacation
          } ${t('common:labels.times.days')}`}</Typography>
        </InfoElement>
      </InfoBlock>
    </InfoWrapper>
  );
};

export default LimitedWorkingConditions;
